import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_xl",
  "use": "icon-arrow_xl-usage",
  "viewBox": "0 0 29 53",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 53\" id=\"icon-arrow_xl\">\n    <path d=\"M1070,3858.94l3-2.94,26,26.5-26,26.5-3-2.94,24-23.56Z\" transform=\"translate(-1070 -3856)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol